export default class SearchListHandler {

    constructor() {

        this.bindEvents();

    }

    bindEvents() {

        let _this = this;
        let searchFields = document.querySelector('input.ahx-wcpl-search-field');
        if ( searchFields ) {
            searchFields.addEventListener('keyup', function() {
                _this.filterRows( this );
            });
        }

    }

    filterRows( input ) {

        let filter  = input.value.toLowerCase();
        let table   = document.getElementById('product_list_items');
        let rows    = document.querySelectorAll('#product_list_items .row');
        rows.forEach( function( row ) {
            let keywords = JSON.parse(row.dataset.keywords);
            let toggle = false;
            keywords.forEach( function( keyword ) {
                if ( keyword.toLowerCase().indexOf( filter ) > -1 ) {
                    toggle = true;
                    return false;
                }
            });
            row.style.display = toggle ? '' : 'none';
        });

        document.dispatchEvent(
            new CustomEvent("searchFilterRows", {
                detail: {table: table},
            }),
        );

    }

}